import { createSelector } from '@reduxjs/toolkit';

import { AppState } from '@/redux/helper';
import { selectHasExplorerFeature } from '@/redux/selectors/users';

// eslint-disable-next-line import/prefer-default-export
export const selectShouldPlayAdvertisement = createSelector(
  [
    (state: AppState) => state.user.logged,
    selectHasExplorerFeature,
    (state: AppState) => state.settings.advertisements.shouldShowAd,
  ],
  (logged, hasExplorerFeature, shouldShowAd) => {
    if (!logged) {
      return shouldShowAd;
    }
    if (hasExplorerFeature) {
      return false;
    }
    return shouldShowAd;
  },
);
